export enum AppEnv {
  PROD = 'PROD',
  TEST = 'TEST',
  DEV = 'DEV',
  LOCAL = 'LOCAL',
}
